// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__2KCB0","active":"card_active__2tcFZ","content":"card_content__23WRN","fadeIn":"card_fadeIn__3_rBU"};